"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateLootShopItemResponseToJSON = exports.UpdateLootShopItemResponseFromJSONTyped = exports.UpdateLootShopItemResponseFromJSON = void 0;
var _1 = require("./");
function UpdateLootShopItemResponseFromJSON(json) {
    return UpdateLootShopItemResponseFromJSONTyped(json, false);
}
exports.UpdateLootShopItemResponseFromJSON = UpdateLootShopItemResponseFromJSON;
function UpdateLootShopItemResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'item': (0, _1.MenuItemFromJSON)(json['item']),
    };
}
exports.UpdateLootShopItemResponseFromJSONTyped = UpdateLootShopItemResponseFromJSONTyped;
function UpdateLootShopItemResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'item': (0, _1.MenuItemToJSON)(value.item),
    };
}
exports.UpdateLootShopItemResponseToJSON = UpdateLootShopItemResponseToJSON;
